module.exports = {
  accentColor: '#448AFF',
  floatingNav: {
    background: 'rgba(56, 87, 138, 0.94)',
    chevron: '#FFA726',
    color: '#FFF'
  },
  headerColor: '#448AFF',
  selectionColor: '#559FFF',
  textColor: {
    active: '#FFF',
    default: '#333'
  },
  todayColor: '#FFA726',
  weekdayColor: '#559FFF'
};


//////////////////
// WEBPACK FOOTER
// ../~/react-infinite-calendar/es/utils/defaultTheme.js
// module id = 2014
// module chunks = 1